// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file ids.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ids.proto.
 */
export const file_ids: GenFile = /*@__PURE__*/
  fileDesc("CglpZHMucHJvdG8SDGNyeXB0b3RyYWRlciIaCglBY2NvdW50SWQSDQoFdmFsdWUYASABKAkiGQoIU2NyaXB0SWQSDQoFdmFsdWUYASABKAkiGwoKQmFja3Rlc3RJZBINCgV2YWx1ZRgBIAEoCSIXCgZVc2VySWQSDQoFdmFsdWUYASABKAkiGgoJQ2hhbm5lbElkEg0KBXZhbHVlGAEgASgJIhwKC1RpY2tlckJvdElkEg0KBXZhbHVlGAEgASgJQkdaRWNvZGViZXJnLm9yZy9DcnlwdG9UcmFkZXIvYXBwL3Byb3RvL2dlbi9jcnlwdG90cmFkZXJwYjtjcnlwdG90cmFkZXJwYmIGcHJvdG8z");

/**
 * @generated from message cryptotrader.AccountId
 */
export type AccountId = Message<"cryptotrader.AccountId"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message cryptotrader.AccountId.
 * Use `create(AccountIdSchema)` to create a new message.
 */
export const AccountIdSchema: GenMessage<AccountId> = /*@__PURE__*/
  messageDesc(file_ids, 0);

/**
 * @generated from message cryptotrader.ScriptId
 */
export type ScriptId = Message<"cryptotrader.ScriptId"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message cryptotrader.ScriptId.
 * Use `create(ScriptIdSchema)` to create a new message.
 */
export const ScriptIdSchema: GenMessage<ScriptId> = /*@__PURE__*/
  messageDesc(file_ids, 1);

/**
 * @generated from message cryptotrader.BacktestId
 */
export type BacktestId = Message<"cryptotrader.BacktestId"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message cryptotrader.BacktestId.
 * Use `create(BacktestIdSchema)` to create a new message.
 */
export const BacktestIdSchema: GenMessage<BacktestId> = /*@__PURE__*/
  messageDesc(file_ids, 2);

/**
 * @generated from message cryptotrader.UserId
 */
export type UserId = Message<"cryptotrader.UserId"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message cryptotrader.UserId.
 * Use `create(UserIdSchema)` to create a new message.
 */
export const UserIdSchema: GenMessage<UserId> = /*@__PURE__*/
  messageDesc(file_ids, 3);

/**
 * @generated from message cryptotrader.ChannelId
 */
export type ChannelId = Message<"cryptotrader.ChannelId"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message cryptotrader.ChannelId.
 * Use `create(ChannelIdSchema)` to create a new message.
 */
export const ChannelIdSchema: GenMessage<ChannelId> = /*@__PURE__*/
  messageDesc(file_ids, 4);

/**
 * @generated from message cryptotrader.TickerBotId
 */
export type TickerBotId = Message<"cryptotrader.TickerBotId"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message cryptotrader.TickerBotId.
 * Use `create(TickerBotIdSchema)` to create a new message.
 */
export const TickerBotIdSchema: GenMessage<TickerBotId> = /*@__PURE__*/
  messageDesc(file_ids, 5);

